<template>
  <Drawer title="博实结部标-离线" width="1024"  :closable="false" v-model="_value">

<!--    <div>-->
<!--      <span>离线原因-->
<!--      <ul class="numstyleone">-->
<!--        <li class="li">SIM卡失效</li>-->
<!--          <div>-->
<!--            <span>处理方案-->
<!--               <ul class="numstyletwo">-->
<!--                 <li class="li">-->
<!--                  查询SIM卡是否已停止使用，重新开通-->
<!--                 </li>-->
<!--                 <li class="li">-->
<!--                   更换SIM卡-->
<!--                 </li>-->
<!--              </ul>-->
<!--            </span>-->
<!--          </div>-->
<!--        <li class="li">设备参数异常</li>-->
<!--        <li class="li">平台与设备主机号不一致</li>-->
<!--      </ul>-->
<!--      </span>-->

<!--    </div>-->

    <Skeleton animated>
      <List item-layout="vertical">
        <ListItem v-for="item in data" :key="item.title">
          <ListItemMeta :title="item.title"/>
          {{ item.description }}<br/>
          {{ item.content }}<br/>
          {{ item.dispose }}
          <Button v-if="item.pdfSrc" type="primary" size="small" @click="openpdf(item.pdfSrc)" style="margin: 10px;">详细文档</Button>
          <iframe-modal v-model="Iframemodal" :initValue="IframeId"></iframe-modal>
          <template #extra>
            <img :src="item.imgSrc" style="width: 580px">
          </template>
        </ListItem>
      </List>
    </Skeleton>

<!--  下面是引入自建组件例子  -->
<!--    <maintain-order-add-maintain-device-record-modal v-model="maintainOrderAddMaintainDeviceRecordModal" :initValue="maintainOrderAddMaintainDeviceRecordId"></maintain-order-add-maintain-device-record-modal>-->

  </Drawer>
</template>

<script>

/**
   * 引入自建组件/框架组件等位置
   */
import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

/**
   * 引入自建组件
  */
// import MaintainOrderAddMaintainDeviceRecordModal
//   from '@/view/om/components/maintain-order-add-maintain-device-record-modal'

import IframeModal from '@/view/om/technicalassistance/components/iframe-modal'

export default {
  name: 'bsja6bdofflinemodal',
  /**
     * 与组件引入的组件名一致，使用该组件
     * 下面是引入自建组件例子
     */
  components: {
    // MaintainOrderAddMaintainDeviceRecordModal,
    IframeModal
  },
  /**
     * 作为组件对应传送字段
     */
  props: {
    initValue: null,
    terminalNumValue: null,
    value: {
      type: Boolean,
      default: false
    },

    Iframemodal: false,
    IframeId: false
  },
  /**
     * 默认数据/字段名创建
     */
  data () {
    return {
      /**
         * 下面是引入自建组件例子
         */
      maintainOrderAddMaintainDeviceRecordModal: false,
      maintainOrderAddMaintainDeviceRecordId: false,

      data: [
        {
          title: 'SIM卡失效',
          description: '1、联系相关人员查询该SIM卡是否在正常使用状态。',
          content: '2、安排上门维修更换SIM卡'
          // imgSrc: '/设备参数.png',
        },

        {
          title: '设备参数异常',
          description: '1、查询设备离线平台通道的IP，端口，协议，协议版本等是否正确。把错误的参数重新设置',
          imgSrc: '/BSJ/A6BD/Parameterexception.jpg'
        },
        {
          title: '平台与设备主机号不一致',
          description: '1、查询离线平台录入资料，与设备填写主机号（中心识别码）是否一致。修改正确的资料（两客一危平台为准）',
          imgSrc: '/BSJ/A6BD/Parameterexception.jpg'
        },
        {
          title: '4G通信天线异常',
          description: '1、检查4G通信天线与设备主机是否松脱,重新插拔4G通信天线',
          content: '2、安排上门维修更换4G通信天线',
          imgSrc: '/BSJ/A6BD/Plugantenna.jpg'
        },
        {
          title: '设备无电源',
          description: '1、车辆通电，设备显示屏无反应，安排上门维修更换设备主机'
          // imgSrc: '/BSJ/A6BD/Parameterexception.jpg',
        },
        {
          title: '设备模块损坏',
          description: '1、安排上门维修更换设备主机'
          // imgSrc: '/BSJ/A6BD/Parameterexception.jpg',
        }
      ]
    }
  },
  /**
   * 方法存储位置
   */
  methods: {
    ...mapActions([
      'VehicleInfoServ_SearchByName'
    ]),
    openpdf (e) {
      this.Iframemodal = true
      this.IframeId = e
    }
  },
  /** 作为组件的数值传输字段
     */
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    _terminalNumValue: {
      get () {
        return this.terminalNumValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  /**
   * 页面加载执行的代码
   * 可调用方法存储位置中的方法
   */
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>

<!--样式库-->
<style scoped>
  .numstyleone{
    list-style-type: upper-roman;
    width:100%;
  }
  .numstyletwo{
    list-style-type: upper-alpha;
  }
  .numstyleone.numstyletwo.li{
    width:80px;
    float:left;
  }
</style>
